import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { Helmet } from "react-helmet-async";
import Swal from "sweetalert2";

const RefKelas = () => {
    const [kelas, setKelas] = useState([]); // State untuk menyimpan daftar kelas
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        rombel_id: "",
        initial: "",
        nama_rombel: "",
        tingkat: "10",
        jenis_rombel: "Umum"
    });
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // State untuk loading

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Aktifkan loading

        Swal.fire({
            title: "Menyimpan...",
            text: "Mohon tunggu sebentar.",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            console.log(formData);
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/inputkelas`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan data");
            }

            const result = await response.json();

            Swal.fire("Berhasil!", result.message, "success").then(() => {
                $('.table').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
            });

            setError('');
            setFormData({
                rombel_id: "",
                initial: "",
                nama_rombel: "",
                tingkat: "10",
                jenis_rombel: "Umum"
            });

        } catch (error) {
            Swal.fire("Error!", error.message || 'Terjadi kesalahan', "error");
            setError(error.message || 'Terjadi kesalahan');
        } finally {
            setIsLoading(false); // Matikan loading setelah proses selesai
        }
    };

    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
    };

    const handleNew = () => {
        setIsEditing(false);
        setFormData({
            rombel_id: "",
            initial: "",
            nama_rombel: "",
            tingkat: "10",
            jenis_rombel: "Umum"
        });
    };

    useEffect(() => {
        $('.table').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/admin/refrensi/getkelas`,
                type: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
               
                dataSrc: "data",
            },
            columns: [
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<small>${data.initial}</small><br/><b>${data.nama_rombel}</b>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        return `<center>
                            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${row.rombel_id}'>
                                 <i class="ti ti-users f-20"></i> - ${row.jml_siswa} 
                            </a>
                            </center>
                           
                        `;
                    }
                },

                {
                    data: null,
                    render: function (data, type, row) {
                        return `
                        <center>
                            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${row.rombel_id}'>
                                 <i class="ti ti-layout-list f-20"></i> - ${row.jml_siswa} 
                            </a>
                            </center>
                           
                        `;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        setKelas(row)
                        return `
                      <div class="btn-group">
  <button 
    class="btn btn-light btn-sm dropdown-toggle" 
    type="button" 
    data-bs-toggle="dropdown" 
    aria-expanded="false"
    style="border: none;">
    <i class="ti ti-dots-vertical"></i>
  </button>
  <ul class="dropdown-menu dropdown-menu-end">
    <li>
      <a 
        href="#" 
        class="dropdown-item edit-btn" 
        data-bs-toggle="modal" 
        data-bs-target="#ujianModal" 
        data-row='${JSON.stringify(row)}'>
        <i class="ti ti-edit me-2"></i> Ubah
      </a>
    </li>
    <li>
      <a 
        href="#" 
        class="dropdown-item delete-btn text-danger" 
        data-id="${row.rombel_id}">
        <i class="ti ti-trash me-2"></i> Hapus
      </a>
    </li>
  </ul>
</div>



                    
                           
                            
                        `;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });

        return () => {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }
        };
    }, []);


    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");

        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                console.log({ rombel_id: id })
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapuskelas`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",

                    },
                    credentials: 'include',
                    body: JSON.stringify({ rombel_id: id })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                            $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                        } else {
                            Swal.fire("Gagal!", data.message, "error");
                        }
                    })
                    .catch(error => {
                        Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                    });
            }
        });
    });


    return (
        <>
            <Helmet>
                <title>Kelas Griya Vidya</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">
                                <div className="card">

                                    <div className="card-body">
                                        <div className='row mb-3 align-items-center'>
                                            <div className="col"><small className="text-muted">Refrensi</small><h3>Kelas / Rombel</h3></div>

                                            <div className='col-auto'>
                                                <button
                                                    type="button"
                                                    className="btn btn-info d-inline-flex align-items-center"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#ujianModal"
                                                    onClick={handleNew}
                                                >
                                                    <i className="ti ti-plus me-2"></i>
                                                    Data Baru
                                                </button>
                                            </div>
                                        </div>
                                        <hr />
                                        {/* Tabel kelas */}
                                        <table className="table table-hover datatable-table" >
                                            <thead>
                                                <tr>
                                                    <th width="50">#</th>
                                                    <th scope="col">Kelas</th>
                                                    <th width="50"><center>Anggota Rombel</center></th>
                                                    <th width="50"><center>Pembelajaran</center></th>
                                                    <th width="50"><center>Tindakan</center></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                        </table>
                                        {/* Tampilkan error jika ada */}
                                        {error && <div className="alert alert-danger">{error}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal Input/Edit */}
                <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog">
                        <form onSubmit={handleSubmit} className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{isEditing ? "Edit Kelas" : "Tambah Kelas"}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Initial</label>
                                    <input type="text" className="form-control" maxLength={10} name="initial" value={formData.initial} onChange={handleChange} required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Nama Rombel</label>
                                    <input type="text" className="form-control" name="nama_rombel" value={formData.nama_rombel} onChange={handleChange} required />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Tingkat Kelas</label>
                                    <select name='tingkat' className="form-select" value={formData.tingkat} onChange={handleChange} required>
                                        <option value={10}>Kelas 10</option>
                                        <option value={11}>Kelas 11</option>
                                        <option value={12}>Kelas 12</option>
                                        <option value={13}>Kelas 13</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Tingkat Kelas</label>
                                    <select name='jenis_rombel' className="form-select" value={formData.jenis_rombel} onChange={handleChange} required>
                                        <option>Umum</option>
                                        <option>Pilihan</option>
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    Batal
                                </button>
                                <button type="onSubmit" className="btn btn-primary" data-bs-dismiss="modal" disabled={isLoading}>

                                    {isLoading ? "Menyimpan..." : isEditing ? "Update" : "Simpan"}

                                </button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </>
    );
};

export default RefKelas;
